export enum FamilyMembersLogs {
  UpdateResident = "Update Resident",
  UpdateFamilyLastActive = "Update Family Last Active",
  UpdateFamilyAppStatus = "Update Family App Status",
  UpdateFamilyAvatar = "Update Family Avatar",
  UpdateFamilyName = "Update Family Name",
  UpdateUserStory = "Update User Story",
  UpdateLastIP = "Update Last IP",
  SetCall = "Set Call",
  CancelBookingRequest = "Cancel Booking Request",
  AddResidentToWaitingList = "Add Resident To Waiting List",
  RemoveResidentFromWaitingList = "Remove Resident From Waiting List",
  DeleteFamily = "Delete Family",
  UpdateNotificationPreferences = "Update Notification Preferences",
  ApproveRequestApproval = "Approve Request Approval",
  RejectRequestApproval = "Reject Request Approval",
  UpdateScheduledCall = "Update Scheduled Call",
  DeleteScheduledCall = "Delete Scheduled Call",
  BookingConcierge = "Booking Concierge",
  ViewCarePlan = "View Care Plan",
  AddFamilyMember = "Add Family Member",
  ChangeFamilyMembersAccess = "Change Family Members Access",
  CompleteSurvey = "Complete Survey",
  CreateScheduledCallRequest = "Create Scheduled Call Request",
  ApprovedScheduledCallRequest = "Approved Scheduled Call Request",
  RejectedScheduledCallRequest = "Rejected Scheduled Call Request",
  UpdateScheduledCallRequest = "Update Scheduled Call Request",
  DailyPlan = "Daily Plan",
  DailyCare = "Daily Care",
  CareDocument = "Care Document",
  CareNoteStory = "Care Note Story",
  EditMemberAccess = "Edit Member Access",
}

export enum FamilyMembersLogsTypes {
  Audit = "Audit",
  Care = "Care"
}

export const FamilyMembersCareLogs: ({title: string; value: string})[] = [
  {
    title: "Daily Plan",
    value: "dailyPlan"
  },
  {
    title: "Daily Care",
    value: "dailyCare"
  },
  {
    title: "Care Document",
    value: "ticketForCarePlan"
  },
  {
    title: "Care Note Story",
    value: "careNoteStory"
  }
]
